import React from "react";
const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path d="M5.104 3.542a1.563 1.563 0 0 0-1.562 1.562v9.792a1.563 1.563 0 0 0 1.562 1.562h9.792a1.563 1.563 0 0 0 1.562-1.562v-3.542a.52.52 0 1 1 1.042 0v3.542a2.605 2.605 0 0 1-2.604 2.604H5.104A2.604 2.604 0 0 1 2.5 14.896V5.104A2.604 2.604 0 0 1 5.104 2.5h3.542a.52.52 0 1 1 0 1.042H5.104Zm6.146-.521a.52.52 0 0 1 .52-.521h5.21a.52.52 0 0 1 .52.52v5.21a.521.521 0 0 1-1.042 0V4.277l-4.319 4.32a.521.521 0 0 1-.736-.737l4.319-4.32H11.77a.521.521 0 0 1-.521-.52Z" />
  </svg>
);

export default icon;
